<div class="title">
    <div mat-dialog-title >Warning</div>
    <button (click)="onCancel()" aria-label="Close dialog" tabindex="-1">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content>
    <p><strong>Another meeting is scheduled soon</strong></p>
    <p>
        A scheduled meeting starts at {{ data.time }}.
        If you create this meeting now, it will end automatically before 5 minutes.
    </p>
</mat-dialog-content>

<mat-dialog-actions align="end" class="action-btn">
    <button class="change-room-btn" (click)="onCancel()">Change Room</button>
    <button class="create-btn" (click)="onConfirm()">
        Create Meeting
    </button>
</mat-dialog-actions>